var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31438 20.9933C5.5567 15.8244 5.47534 10.8468 5.62423 5.60393C5.65316 4.58002 4.86714 3.72877 3.86955 3.69793C2.87136 3.66709 2.03831 4.47514 2.00878 5.49904C1.86773 10.4705 1.98167 15.2014 0.802645 20.1112C0.563948 21.1043 1.15769 22.1097 2.12695 22.3502C3.0956 22.5969 4.07629 21.9863 4.31438 20.9933Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8694 31.0103C23.2973 23.1274 31.2383 12.9871 36.7886 2.7481C37.2726 1.85373 36.9573 0.72492 36.0845 0.231472C35.2117 -0.261974 34.1099 0.0587921 33.6258 0.953165C28.2588 10.8529 20.5789 20.6602 12.4294 28.2778C11.6928 28.9687 11.6416 30.1406 12.3149 30.8931C12.9882 31.6456 14.1328 31.7011 14.8694 31.0103Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.004 39.6209C24.7123 40.9224 32.6574 38.7019 39.6664 35.5624C40.5808 35.1491 40.9979 34.0574 40.5983 33.126C40.1981 32.1884 39.1305 31.7628 38.2161 32.1699C31.8328 35.0319 24.6134 37.1537 17.5929 35.9695C16.608 35.8029 15.6767 36.4876 15.5146 37.493C15.3518 38.4984 16.0197 39.4544 17.004 39.6209Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.ab9b97a08f69993df661df36b671012d.svg";
export { ForwardRef as ReactComponent };